import { inject, Injectable } from "@angular/core";
import { JobMailOption } from "./jkJob";
import { jkAlert } from "./jkClass";
import { downloadURI } from "./jkCommon";
import { JkEnvironment, jkRestReturn } from "./jkInterface";
import { OrmService } from "./jkOrm";
import { login, LoginService } from "./jkUser";
//import { JkgridwinComponent } from "../components/jkgridwin/jkgridwin.component";

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  urlPath: string = '';
  //reportUrl: string = '';
  dbname: string = '';
  fileName: string = '';
  login: LoginService;// = inject(LoginService);
  orm: OrmService = inject(OrmService);
  constructor() {
    this.login= login;
    this.dbname = this.login.dbname;
  }
  /*init(env:JkEnvironment){
    this.reportUrl = env.reportUrl;
  }*/
  setReportPath(reportUrl: string,file:string):string{
    if(file){
      this.fileName = file;
      this.urlPath = reportUrl + '/'+ this.dbname +'/'+file;
    }else{
      this.urlPath = '';
      this.fileName = '';
    }
    return this.urlPath;
  }
  async downloadReport(reportUrl:string,focusedRowIndex:number,itemList:any[]):Promise<boolean> {
    if (focusedRowIndex < 0) {
      jkAlert('請選擇一筆資料', '打開報表');
      return false;
    }
    if (itemList.length === 0) {
      jkAlert('無資料', '打開報表');
      return false;
    }
    //let uri: string;
    let item = itemList[focusedRowIndex];
    if (item['成功筆數'] === 0) {
      jkAlert('無符合資料.未產生報表', '打開報表');
      return false;
    }
    // 設定 urlPath iFrame 的路徑, 並顯示 iFrame
    //this.urlPath = this.reportUrl + "/" + Login.dbname + "/" + item["FILENAME"]; //myTable.rowData["FILENAME"];
    this.setReportPath(reportUrl,item['FILENAME']);
    downloadURI(this.urlPath);
    return true;
  }
  openReport(reportUrl:string,focusedRowIndex:number,itemList:any[]){
        if (focusedRowIndex < 0) {
          jkAlert('請選擇一筆資料', '打開報表');
          return false;
        }
        //let uri: string;
        let item = itemList[focusedRowIndex];
        if (item['成功筆數'] === 0) {
          jkAlert('無符合資料.未產生報表', '打開報表');
          return false;
        }
        // 設定 urlPath iFrame 的路徑, 並顯示 iFrame
        this.setReportPath(reportUrl,item['FILENAME']);
    return true;
  }
  mail(pageOpt:JobMailOption,ret:jkRestReturn){
    /* {"from":"nobody1@jack168.com","to":"jackie@jack168.com","subject":"test","text":"http://jack168.com/report/JACKIE/20240504-1449-MTRKR03.PDF  "}*/
    if (!pageOpt.mailFrom || !pageOpt.mailTo) {
      jkAlert('請設定寄件人與收件人');
      return;
    }
    let body = {
      from: pageOpt.mailFrom,
      to: pageOpt.mailTo,
      subject: '報表:' + this.fileName,
      text: this.urlPath,
    };
    this.orm.sendMail(body, ret).subscribe(
      (data) => {
        if (data.errorLog) {
          jkAlert(data.errorLog);
        } else {
          jkAlert('Mail sent');
        }
      },
      (error) => {
        jkAlert('Mail sent error:' + error.message);
      }
    );
    //alert('Mail功能尚未完成');

  }
}
